import { ToggleButtonAppearance as FluentButtonAppearance, ToggleButtonShape as FluentButtonShape, ToggleButtonSize as FluentButtonSize, ButtonFormTarget as FluentButtonFormTarget, ButtonType as FluentButtonType } from "@fluentui/web-components";
/** Appearance values for {@link ToggleButton}. */
export const ToggleButtonAppearances = {
    ...FluentButtonAppearance
};
/** Shape values for {@link ToggleButton}. */
export const ToggleButtonShapes = { ...FluentButtonShape };
/** Size values for {@link ToggleButton}. */
export const ToggleButtonSizes = { ...FluentButtonSize };
/** Type values for {@link ToggleButton}. */
export const ToggleButtonTypes = { ...FluentButtonType };
/** Type values for {@link ToggleButton}. */
export const ToggleButtonFormTargets = { ...FluentButtonFormTarget };
//# sourceMappingURL=toggle-button.options.js.map